module.exports = __webpack_public_path__ + "static/media/WuerthBold.8aa8795a.ttf";